import { useQuery } from '@tanstack/react-query';

import { fetchEscritorio, fetchEscritorios } from '@/api/client';
import { fetchEquipes } from '@/api/equipes';
import { useAtuacao } from '@/lib/delegacao/atuacao';
import { queryKeys } from '@/lib/pwa/queryConfig';
import { queryPersistMeta } from '@/lib/pwa/queryPersistence';

/**
 * O escritório em que o usuário distribui os processos (§19), com os membros e as equipes
 * para o "Quem cuida". O primeiro em que é gestor — quase sempre o único. ``null``: não é
 * gestor em nenhum (o acervo não oferece distribuir).
 */
export function useDistribuicao() {
  // A mesma query de escritórios da visão do escritório (``['escritorios']``). Na delegação,
  // quem atua pelo titular não distribui por ele.
  const atuacao = useAtuacao();
  const escritorios = useQuery({
    queryKey: ['escritorios'],
    queryFn: fetchEscritorios,
    meta: queryPersistMeta.nonEmpty,
  });
  const escritorio = atuacao ? null : (escritorios.data?.find((e) => e.sou_gestor) ?? null);
  const id = escritorio?.id ?? '';
  const detalhe = useQuery({
    queryKey: queryKeys.escritorios.detail(id),
    queryFn: () => fetchEscritorio(id),
    enabled: !!id,
  });
  const equipes = useQuery({
    queryKey: queryKeys.escritorios.equipes(id),
    queryFn: () => fetchEquipes(id),
    enabled: !!id,
  });
  if (!escritorio || !detalhe.data) return null;
  return { escritorioId: id, membros: detalhe.data.membros, equipes: equipes.data ?? [] };
}
